import { DEFAULT_DELIMITER_COLOR } from '../const';

/**
 * Парсер элемента div-separator-element
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-table-block.json
 * @param  {Object} element
 * @return {Object}
 */
export default (function (element) {
  return {
    color: element.color || DEFAULT_DELIMITER_COLOR,
    type: element.type,
    weight: 0
  };
});